
import React from 'react';
import Text from './styledText.styled';
import { DARK_NAVY_FONT_COLOR, BASE_TEXT_PX, FONT_FAMILY_REGULAR } from '../../../styles/fonts/MCFontConstants';

const StyledText = React.memo(({
    fontColor = DARK_NAVY_FONT_COLOR,
    fontSize = BASE_TEXT_PX,
    fontFamily = FONT_FAMILY_REGULAR,
    letterSpacing = '1',
    children = <>Styled Text</>,
    opacity = '1',
    showRedAsterisk = false,
    showPerpleAsterisk = false,
    margin,
    textAlign,
    height,
    width,
    mbFontColor,
    textTransform,
    display = false,
    onClick,
    cursor,
    marginBottom = '',
    whiteSpace,
    id,
    mbMargin
}) => (
    <Text
        fontColor={fontColor}
        fontSize={fontSize}
        fontFamily={fontFamily}
        letterSpacing={letterSpacing}
        opacity={opacity}
        showRedAsterisk={showRedAsterisk}
        showPerpleAsterisk={showPerpleAsterisk}
        margin={margin}
        textAlign={textAlign}
        height={height}
        width={width}
        mbFontColor={mbFontColor}
        textTransform={textTransform}
        onClick={onClick}
        cursor={cursor}
        display={display}
        marginBottom={marginBottom}
        id={id}
        whiteSpace={whiteSpace}
        mbMargin = {mbMargin}
    >
        {children}
    </Text>
));

export default StyledText;